import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export enum ChannelPromotionType {
  lastMinute = 'last_minute',
  earlyBooking = 'early_booking',
  newListing = 'new_listing',
  mobileOnly = 'mobile_only',
  memberOnly = 'member_only',
}

export enum ChannelPromotionStatus {
  active = 'active',
  inactive = 'inactive',
}

export enum ChannelPromotionChannel {
  homeaway = 'home_away',
}

export const MEMBER_ONLY_TIERS = ['blue', 'silver', 'gold'] as const;

export type MemberOnlyTier = (typeof MEMBER_ONLY_TIERS)[number];

export type MemberOnlyTiers = Partial<Record<MemberOnlyTier, number>>;

export default class ChannelPromotionModel extends Model {
  @attr('string') externalId!: string;
  @attr('string') channel!: ChannelPromotionChannel;
  @attr('string') type!: ChannelPromotionType;
  @attr('number') value!: number | null;
  @attr('string') status!: ChannelPromotionStatus;
  @attr('number') minAdvanceDays!: number;
  @attr('number') maxAdvanceDays!: number;
  @attr('object') tiers!: MemberOnlyTiers;

  @belongsTo('property', { async: false, inverse: 'channelPromotions' })
  property!: ModelRegistry['property'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'channel-promotion': ChannelPromotionModel;
  }
}
